function generateShortcutLink(ssoSubdomain, accountId, projectUrl) {
  return `https://${ssoSubdomain}.awsapps.com/start/#/console?account_id=${accountId}&destination=${encodeURIComponent(
    projectUrl
  )}`;
}

export { generateShortcutLink };
//# sourceMappingURL=generateShortcutLink.esm.js.map
